// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { EnquiryResponseNewCustomerFragmentDoc } from '../../../../../../components/enquiry/api/enquiryResponseNewCustomer.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateShapeEnquiryEngagementRingCollectionNewCustomerDocument = gql`
    mutation createShapeEnquiryEngagementRingCollectionNewCustomer($input: EnquiryEngagementRingCollectionInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createEnquiryEngagementRingPreferAnotherShapeNewCustomer(
    input: $input
    customer: $customer
  ) {
    ...enquiryResponseNewCustomer
  }
}
    ${EnquiryResponseNewCustomerFragmentDoc}`;

export function useCreateShapeEnquiryEngagementRingCollectionNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateShapeEnquiryEngagementRingCollectionNewCustomerMutation, SchemaTypes.CreateShapeEnquiryEngagementRingCollectionNewCustomerMutationVariables>(CreateShapeEnquiryEngagementRingCollectionNewCustomerDocument);
};